import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import axios from "axios";
import { Article } from "@/modules/homepage/definitions/types";
import dayjs from "../../../modules/shared/libs/dayjs";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import IcLinkSVG from "../../../modules/shared/component/IcLinkSVG";
import { useTheme } from "../../../modules/shared/context/ThemeContext/ThemeProviderContext";
import { Theme } from "../../../modules/shared/definitions/enum";
import PopoverDynamic from "../../../modules/shared/component/dialog/PopoverDynamic";
import copyToClipboard from "../../../modules/shared/utilities/copyToClipboard";

interface ImageDetail {
  image: string;
}

const NewsDetailContent: React.FC = () => {
  const theme = useTheme();
  const { id } = useParams<{ id: string }>();
  const [articlesDetail, setArticlesDetail] = useState<Article | null>(null);
  const [imagesDetail, setImagesDetail] = useState<ImageDetail[]>([]);

  useEffect(() => {
    const getArticles = async () => {
      const response = await axios.get(
        `https://divhubinter.polri.go.id/api/artikel/${id}`,
      );
      setArticlesDetail(response.data.artikel[0]);
      setImagesDetail(response.data.image);
    };

    getArticles();
  }, [id]);

  return (
    <div className="container phone-s:max-w-full laptop:w-11/12 mx-auto py-12">
      {/* <div className="container max-w-5xl mx-auto py-12 px-2"> */}
      <div className="rounded-2xl shadow-xl overflow-hidden">
        <div className="p-6 md:p-10">
          {/* Breadcrumbs */}
          <div className="text-sm breadcrumbs mb-2">
            <ul className="flex gap-2">
              <li>
                <Link
                  to={"/berita"}
                  className="text-blue-700 dark:text-blue-300 hover:underline"
                >
                  Berita
                </Link>
              </li>
              <li className="text-gray-400 dark:text-gray-500">News</li>
            </ul>
          </div>
          {/* Title */}
          <h2 className="text-3xl md:text-4xl font-bold mb-2">
            {articlesDetail?.artikel_judul}
          </h2>
          {/* Date */}
          <div className="text-sm text-gray-500 dark:text-gray-400 mb-4">
            {dayjs(articlesDetail?.artikel_tanggal).format("DD MMMM YYYY")}
          </div>
          {/* Share & Link */}
          <div className="flex items-center flex-wrap gap-3 mb-6">
            <PopoverDynamic
              renderPopoverContent={() => (
                <div className="tooltip-headless font-medium rounded-lg absolute -top-[calc(100%+68px)] left-1 mt-2 max-w-[300px] border-2 border-black bg-white px-5 py-3 text-sm text-black">
                  Link berhasil disalin
                </div>
              )}
            >
              <IcLinkSVG
                fill={theme === Theme.DARK ? "#FFF" : "#204d84"}
                className="w-6 h-6 cursor-pointer hover:scale-110 transition"
                onClick={() => copyToClipboard(window.location.href)}
              />
            </PopoverDynamic>
            <FacebookShareButton url={window.location.href}>
              <FacebookIcon size={28} round />
            </FacebookShareButton>
            <TwitterShareButton url={window.location.href}>
              <XIcon size={28} />
            </TwitterShareButton>
            <WhatsappShareButton url={window.location.href}>
              <WhatsappIcon size={28} round />
            </WhatsappShareButton>
          </div>
          {/* Divider */}
          <div className="h-[1px] w-full bg-gray-200 dark:bg-gray-700 mb-6"></div>
          {/* Carousel */}
          <div className="flex items-center justify-center mx-auto w-full">
            <Carousel
              showArrows={true}
              showIndicators={true}
              infiniteLoop={false}
              dynamicHeight={false}
              autoPlay={false}
              showStatus={false}
              showThumbs={false}
              className="w-full"
            >
              {[
                // First, render the thumbnail image from articlesDetail
                <div key="thumbnail">
                  <div className="flex relative bg-cover">
                    {articlesDetail?.artikel_thumbnail && (
                      <img
                        src={`https://divhubinter.polri.go.id${articlesDetail.artikel_thumbnail}`}
                        alt={
                          articlesDetail?.artikel_judul || "Article thumbnail"
                        }
                        className="w-full aspect-[16/9] rounded-xl object-cover"
                        loading="lazy"
                        style={{ pointerEvents: "auto" }}
                      />
                    )}
                  </div>
                </div>,
                // Then, render the images from imagesDetail
                ...imagesDetail.map((image, index) => (
                  <div key={index}>
                    <div className="flex relative bg-cover">
                      <img
                        src={`https://divhubinter.polri.go.id${image.image}`}
                        alt={image.image || `Slide ${index + 1}`}
                        className="w-full aspect-[16/9] rounded-xl object-cover"
                        loading="lazy"
                        style={{ pointerEvents: "auto" }}
                      />
                    </div>
                  </div>
                )),
              ]}
            </Carousel>
          </div>
          {/* Content */}
          <div
            className="text-justify mt-8 leading-relaxed text-lg"
            dangerouslySetInnerHTML={{
              __html: articlesDetail?.artikel_konten || "",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetailContent;
